define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/table/AggregateFrom",
	"csi/xml",
	"./NewColorwayMixin"
], function(array,declare,csi,AggregateFrom,xml,NewColorwayMixin) {

	return declare([AggregateFrom, NewColorwayMixin], {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default name for Colorway on Colorway form - not popup Color table
			this.inherited(arguments);

			var	urlColor = view.getFixedValue ? view.getFixedValue("ColorSpecification") : null;
			if (urlColor) {
				view.defView.m_formData.setFieldInitialValue(xml.ATTR_NAME, view.cacheView.getNode(urlColor).$Name);
				view.addFixedValue("ColorwayThemeColor", csi.EMPTY_URL);
			}
		},

		_getFormView: function(/*Boolean*/bCheckOnly) {
			// summary: add field for adding to BOM
			var	defView = this.inherited(arguments);
			if (defView && !bCheckOnly) {
				this._addBomField(this.getParent(), defView);
			}

			return defView;
		},

		_processFormData: function(/*FormData*/fd) {
			// summary: call method to add to BOM(s) after all other operations
			var	ret = this.inherited(arguments);

			array.forEach(this.urlsAppended, function(url) {
				this._writeBomField(this.m_urlParent, url);
			}, this);

			return ret;
		}
	});
});